import { inject } from '@angular/core';
import { CanMatchFn, Router } from '@angular/router';
import { AuthService, POST_LOGIN_ROUTE } from '../services/auth.service';

/**
 * The mirror image of authGuard, for the sign-in screens: a visitor who
 * already has a session is sent to the member area instead of being shown a
 * login or registration form (and, worse, having a failed re-login there
 * drop the session they had).
 */
export const guestGuard: CanMatchFn = () => {
  const auth = inject(AuthService);
  const router = inject(Router);

  return auth.isAuthenticated() ? router.parseUrl(POST_LOGIN_ROUTE) : true;
};
